const env = process.env.NODE_ENV

const dev = 'paineldoclientera'
const prod = window.location.href.split('.')[0].split('//')[1]
export const api = (target) => `https://${env === 'production' ? prod : dev}.contabil.me/${target}`
